
    export default {
        name: 'JobViewBrandLocation',

        props: {
            companyName: {
                type: String,
                default: '',
            },

            companyLink: {
                type: String,
                default: '',
            },
            primaryCompanyName: {
                type: String,
                default: '',
            },

            primaryCompanyLink: {
                type: String,
                default: '',
            },

            displayPrimaryBrandCrumb: {
                type: Boolean,
                default: false,
            },

            locationLabel: {
                type: String,
                default: '',
            },

            locationLink: {
                type: String,
                default: '',
            },

            isPrivateListing: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            companyNameLabel() {
                return this.isPrivateListing ? 'Private Listing' : this.companyName;
            },
        },
    };
